import { render, staticRenderFns } from "./BannerDetail.vue?vue&type=template&id=71f7f826&scoped=true&"
import script from "./BannerDetail.vue?vue&type=script&lang=js&"
export * from "./BannerDetail.vue?vue&type=script&lang=js&"
import style0 from "./BannerDetail.vue?vue&type=style&index=0&id=71f7f826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f7f826",
  null
  
)

export default component.exports